<footer class="border-t border-zinc-100 py-6">
  <div class="container mx-auto px-4">
    <div class="flex max-lg:flex-col gap-2 items-center justify-between">
      <div class="flex max-sm:flex-col items-center gap-4 xl:gap-10">
        <img
          width="96"
          height="25"
          class="w-24 h-auto"
          src="assets/images/calenso-logo.webp"
          loading="lazy"
          alt="Calenso"
        />
        <span class="text-black text-xs sm:text-sm">Calenso AG by JRNI - All rights reserved 2016 - 2025</span>
      </div>
      <div class="flex flex-wrap items-center max-sm:justify-center gap-y-1 gap-x-6 xl:gap-x-8">
        <a
          [href]="agbLink"
          target="_blank"
          class="text-black hover:text-(--primary) text-xs sm:text-sm transition-colors underline"
        >
          AGBs
        </a>
        <a
          [href]="impressumLink"
          target="_blank"
          class="text-black hover:text-(--primary) text-xs sm:text-sm transition-colors underline"
        >
          Impressum
        </a>
      </div>
    </div>
  </div>
</footer>
